import BaseClient, { type ExtendedAxiosRequestConfig } from '../BaseClient';
import type { AxiosPromise } from 'axios';
import type { FranchiseHubClientInterface, FranchiseHubDashboardResponse } from './franchiseHubClient.types';

export default class CorporateFranchiseHubClient extends BaseClient implements FranchiseHubClientInterface {
    constructor(private teamId: number) {
        super();
    }

    getDashboard(extraConfig?: ExtendedAxiosRequestConfig): AxiosPromise<FranchiseHubDashboardResponse> {
        const url = `/api/v3/teams/${this.teamId}/franchise-hub/dashboard`;
        return this.makeCoreApiRequest(url, 'get', null, null, extraConfig);
    }
}
